import { render, staticRenderFns } from "./contract-formation-button.vue?vue&type=template&id=307f4fed"
import script from "./contract-formation-button.vue?vue&type=script&lang=ts"
export * from "./contract-formation-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports